import { useMemo } from "react";
import ClientMeasurementApi from "./clientMeasurementApi";
import useSessionId from "./useSessionId";

function useClientMeasurementApi() {
    const [sessionId, ] = useSessionId();
    return useMemo(() => new ClientMeasurementApi(sessionId), [sessionId]);
}

export default useClientMeasurementApi;
